export default "__VITE_ASSET__qfuEYh2f__"